import React from "react";
import ByzTitleBox from "../component/title-box";
import { Box, Card, Grid } from "@mui/material";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import FormFiller from "../component/form-filler";
function PageFour() {
  const { t } = useTranslate();
  return (
    <Card sx={{ marginBottom: "5px" }}>
      <ByzTitleBox
        title={
          t("safe-birth-control-form.form-type") +
          " " +
          t("safe-birth-control-form.before-discharge")
        }
      />

      <FormFiller />

      <ByzTitleBox title={t("safe-birth-control-form.complication-other")} />

      <Grid
        item
        xs={12}
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap" }}
      >
        <Grid item sm={6} xs={12} md={4} xl={3}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.labor-atively")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={3}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.abnormal-bleeding")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          margin: "8px",
          p: 2,
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "#63B4FF33",
          borderRadius: "10px",
        }}
      >
        <Box
          style={{
            fontWeight: "bold",
            fontSize: "1rem",
            color: "#2979C3",
          }}
        >
          {t("safe-birth-control-form.mother-info")}
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}
      >
        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.blood-control")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.blood-pressure")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={
              t("safe-birth-control-form.antibiotic") +
              " " +
              t("safe-birth-control-form.medication-necessary")
            }
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.family-planning")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox title={t("safe-birth-control-form.postpartum")}>
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          margin: "8px",
          p: 2,
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "#63B4FF33",
          borderRadius: "10px",
        }}
      >
        <Box
          style={{
            fontWeight: "bold",
            fontSize: "1rem",
            color: "#2979C3",
          }}
        >
          {t("safe-birth-control-form.baby-info")}
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}
      >
        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.baby-feeding")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={
              t("safe-birth-control-form.antibiotic") +
              " " +
              t("safe-birth-control-form.medication-necessary")
            }
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

     

      <Grid
        item
        sm={12}
        xs={12}
        md={12}
        xl={12}
        sx={{
          margin: "8px",
          p: 1,
          borderBottom: "1px solid #F4F7FE",
          backgroundColor: "#F4F7FE",
        }}
      ></Grid>
      <ByzMuiTypography
        sx={{
          margin: "8px",
        }}
        fontWeight={400}
        fontSize={"4px"}
        color={"red"}
      >
        <Grid item sm={12} xs={12} md={12} xl={12}>
          {t("safe-birth-control-form.note-area")}
        </Grid>
      </ByzMuiTypography>
    </Card>
  );
}

export default PageFour;
